// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 用户签到 POST /checkIn */
export async function checkInUsingPOST(options?: { [key: string]: any }) {
  return request<API.BaseResultUserCheckInResp>('/checkIn', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 获取用户签到记录 GET /checkIn/record */
export async function checkInRecordUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.checkInRecordUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListUserCheckInRecordItem>('/checkIn/record', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取用户签到状态 GET /checkIn/status */
export async function checkInStatusUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultUserCheckInStatusResp>('/checkIn/status', {
    method: 'GET',
    ...(options || {}),
  });
}
